var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_shield-tick",
    "data-name": "vuesax/bulk/shield-tick",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.41.156l-5.5,2.06A3.191,3.191,0,0,0,0,4.986v8.1a3.32,3.32,0,0,0,1.18,2.36l5.5,4.11a3.119,3.119,0,0,0,3.53,0l5.5-4.11a3.339,3.339,0,0,0,1.18-2.36v-8.1a3.176,3.176,0,0,0-1.91-2.76L9.48.166A3.4,3.4,0,0,0,7.41.156Z",
    transform: "translate(303.55 189.904)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.357,5.8a.742.742,0,0,1-.53-.22L.218,3.967a.75.75,0,0,1,1.06-1.06l1.08,1.08L6.128.218a.75.75,0,0,1,1.06,1.06l-4.3,4.3A.742.742,0,0,1,2.357,5.8Z",
    transform: "translate(308.302 196.432)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(300 188)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.dc53a9cfeb28eb6a31ec19310c3b87fe.svg";
export { ForwardRef as ReactComponent };